export const types = {
    ADD: 'add',
    UPDATE: 'update',
    REMOVE: 'remove',
    MOVED: 'moved',
    MOVED_IN: 'moved_in',
    MOVED_OUT: 'moved_out',
}

export const targets = {
    WIDGET_GROUP: 'WidgetGroup',
    WIDGET: 'Widget',
}
